const Storage = (storageKey: string) => {
  const read = (key?: string) => {
    const data = localStorage.getItem(storageKey)
    const values = data ? JSON.parse(data) : {}
    return key ? values[key] : values
  }

  const write = (key: string, value: unknown) => {
    const values = read()
    values[key] = value
    const json = JSON.stringify(values)
    localStorage.setItem(storageKey, json)
  }

  return { read, write }
}

export default Storage
